import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSvFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53292)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0014 19.5402H0.00146484V9.48271C0.00146484 9.00664 0.387499 8.62061 0.863573 8.62061H49.1394C49.6154 8.62061 50.0015 9.00664 50.0015 9.48271L50.0014 19.5402Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1388 41.3795H0.863084C0.387011 41.3795 0.000976562 40.9934 0.000976562 40.5174V30.46H50.0009V40.5174C50.0009 40.9935 49.6148 41.3795 49.1388 41.3795Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0004 19.54H0.000488281V30.459H50.0004V19.54Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9796 28.6683C22.9 28.6683 21.208 26.9764 21.208 24.8967C21.208 24.0083 21.5229 23.1456 22.0947 22.4673L22.2595 22.6062C21.7203 23.2456 21.4234 24.059 21.4234 24.8967C21.4234 26.8573 23.0186 28.4527 24.9795 28.4527L24.9796 28.6683Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.5999 27.5547C23.5528 27.6351 23.5295 27.7454 23.5193 27.8574C23.4768 27.8268 23.4316 27.7982 23.3826 27.7743C23.3826 27.7743 23.3085 28.0354 23.3664 28.2234C23.3664 28.2234 23.1698 28.2478 22.9894 28.4288C22.9894 28.4288 23.0516 28.4728 23.1583 28.5186C22.9791 28.6584 22.9238 28.7967 22.9238 28.7967C23.9814 29.3255 24.4883 28.5879 24.5103 28.5548C24.2513 27.8156 23.5999 27.5547 23.5999 27.5547Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.5107 28.555C24.5115 28.557 24.5123 28.5586 24.513 28.5607V28.5518C24.513 28.5518 24.5113 28.5542 24.5107 28.555Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.6232 26.8496C22.5542 26.9002 22.4942 26.9847 22.4445 27.0754C22.4198 27.034 22.3923 26.9935 22.3596 26.9554C22.3596 26.9554 22.2016 27.1483 22.1817 27.3281C22.1817 27.3281 22.0071 27.2769 21.7889 27.3635C21.7889 27.3635 21.8252 27.4232 21.8984 27.501C21.6963 27.5533 21.5991 27.6497 21.5991 27.6497C22.2973 28.4822 22.9943 28.0457 23.025 28.0259C23.0771 27.3076 22.6232 26.8496 22.6232 26.8496Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.0251 28.0259C23.025 28.0278 23.0251 28.0295 23.0249 28.0314L23.0282 28.0239C23.0282 28.0239 23.0259 28.0254 23.0251 28.0259Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.0178 25.9279C21.9424 25.9438 21.8617 25.9911 21.7874 26.0471C21.7824 26.0039 21.7748 25.9604 21.7621 25.917C21.7621 25.917 21.5608 26.017 21.4779 26.1573C21.4779 26.1573 21.3535 26.0504 21.1422 26.0407C21.1422 26.0407 21.1498 26.1033 21.1813 26.1942C20.9959 26.1623 20.8804 26.2055 20.8804 26.2055C21.1453 27.148 21.8796 27.0478 21.9123 27.0428C22.2207 26.4725 22.0178 25.9279 22.0178 25.9279Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.9119 27.043C21.9111 27.0444 21.9106 27.046 21.9097 27.0475L21.9151 27.0425C21.9152 27.0426 21.9127 27.0429 21.9119 27.043Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.7774 24.8777C21.7059 24.8823 21.6226 24.9136 21.5428 24.9533C21.5482 24.9152 21.5513 24.8766 21.5499 24.8374C21.5499 24.8374 21.3458 24.8998 21.2391 25.0114C21.2391 25.0114 21.1516 24.9037 20.9635 24.8696C20.9635 24.8696 20.9561 24.9249 20.9635 25.0075C20.8039 24.9574 20.6899 24.9808 20.6899 24.9808C20.7122 25.8306 21.3961 25.8324 21.4266 25.832C21.8353 25.3746 21.7774 24.8777 21.7774 24.8777Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.4264 25.8321C21.4253 25.8333 21.4245 25.8344 21.4233 25.8357L21.4293 25.8321C21.4294 25.8321 21.4271 25.832 21.4264 25.8321Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.8575 24.0078C21.7962 23.9932 21.7182 23.9978 21.641 24.0105C21.6554 23.9801 21.668 23.9483 21.6768 23.9151C21.6768 23.9151 21.4894 23.9147 21.3709 23.9808C21.3709 23.9808 21.3254 23.8677 21.1765 23.7905C21.1765 23.7905 21.1559 23.835 21.1408 23.9062C21.0199 23.8229 20.9182 23.8132 20.9182 23.8132C20.717 24.5317 21.2902 24.7103 21.3159 24.7178C21.7773 24.4395 21.8575 24.0078 21.8575 24.0078Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.316 24.7178C21.3148 24.7186 21.3137 24.7193 21.3125 24.72L21.3184 24.7186C21.3184 24.7186 21.3165 24.7179 21.316 24.7178Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.4033 22.9501C21.4033 22.9501 21.2079 23.4619 21.511 23.7583C21.511 23.7583 21.9061 23.6416 22.1014 23.2308L21.9352 23.1993L21.8499 22.9434L21.567 23.0691L21.4033 22.9501Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.9536 22.1274C21.9536 22.1274 21.6474 22.5817 21.8754 22.9391C21.8754 22.9391 22.2868 22.9148 22.5701 22.5589L22.4153 22.4907L22.3902 22.2221L22.0862 22.2805L21.9536 22.1274Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0205 28.6683V28.4527C26.9812 28.4527 28.5766 26.8573 28.5766 24.8967C28.5766 24.0591 28.2797 23.2456 27.7405 22.6062L27.9053 22.4673C28.4771 23.1456 28.792 24.0083 28.792 24.8967C28.792 26.9764 27.1001 28.6683 25.0205 28.6683Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.4003 27.5547C26.4474 27.6351 26.4707 27.7454 26.4809 27.8574C26.5234 27.8268 26.5686 27.7982 26.6176 27.7743C26.6176 27.7743 26.6917 28.0354 26.6337 28.2234C26.6337 28.2234 26.8303 28.2478 27.0107 28.4288C27.0107 28.4288 26.9485 28.4728 26.8418 28.5186C27.021 28.6584 27.0763 28.7967 27.0763 28.7967C26.0187 29.3255 25.5118 28.5879 25.4897 28.5548C25.7489 27.8156 26.4003 27.5547 26.4003 27.5547Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.49 28.555C25.4893 28.557 25.4885 28.5586 25.4878 28.5607V28.5518C25.4878 28.5518 25.4895 28.5542 25.49 28.555Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.3772 26.8496C27.4462 26.9002 27.5062 26.9847 27.5558 27.0754C27.5805 27.034 27.6081 26.9935 27.6408 26.9554C27.6408 26.9554 27.7988 27.1483 27.8186 27.3281C27.8186 27.3281 27.9932 27.2769 28.2115 27.3635C28.2115 27.3635 28.1751 27.4232 28.1019 27.501C28.3041 27.5533 28.4012 27.6497 28.4012 27.6497C27.7031 28.4822 27.006 28.0457 26.9753 28.0259C26.9233 27.3076 27.3772 26.8496 27.3772 26.8496Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.9752 28.0259C26.9753 28.0278 26.9752 28.0295 26.9754 28.0314L26.9722 28.0239C26.9722 28.0239 26.9744 28.0254 26.9752 28.0259Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.983 25.9279C28.0584 25.9438 28.1391 25.9911 28.2134 26.0471C28.2184 26.0039 28.226 25.9604 28.2387 25.917C28.2387 25.917 28.4399 26.017 28.5228 26.1573C28.5228 26.1573 28.6473 26.0504 28.8586 26.0407C28.8586 26.0407 28.851 26.1033 28.8194 26.1942C29.0049 26.1623 29.1204 26.2055 29.1204 26.2055C28.8555 27.148 28.1212 27.0478 28.0885 27.0428C27.7801 26.4725 27.983 25.9279 27.983 25.9279Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.0886 27.043C28.0894 27.0444 28.09 27.046 28.0909 27.0475L28.0855 27.0425C28.0853 27.0426 28.0878 27.0429 28.0886 27.043Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.223 24.8777C28.2946 24.8823 28.3779 24.9136 28.4577 24.9533C28.4522 24.9152 28.4492 24.8766 28.4506 24.8374C28.4506 24.8374 28.6547 24.8998 28.7614 25.0114C28.7614 25.0114 28.8489 24.9037 29.037 24.8696C29.037 24.8696 29.0444 24.9249 29.037 25.0075C29.1966 24.9574 29.3105 24.9808 29.3105 24.9808C29.2883 25.8306 28.6044 25.8324 28.5739 25.832C28.1652 25.3746 28.223 24.8777 28.223 24.8777Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.5738 25.8321C28.5749 25.8333 28.5757 25.8344 28.5768 25.8357L28.5708 25.8321C28.5708 25.8321 28.5731 25.832 28.5738 25.8321Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.1436 24.0078C28.2048 23.9932 28.2828 23.9978 28.3601 24.0105C28.3456 23.9801 28.333 23.9483 28.3242 23.9151C28.3242 23.9151 28.5116 23.9147 28.6301 23.9808C28.6301 23.9808 28.6756 23.8677 28.8245 23.7905C28.8245 23.7905 28.8451 23.835 28.8603 23.9062C28.9811 23.8229 29.0828 23.8132 29.0828 23.8132C29.284 24.5317 28.7108 24.7103 28.6852 24.7178C28.2237 24.4395 28.1436 24.0078 28.1436 24.0078Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.6851 24.7178C28.6863 24.7186 28.6873 24.7193 28.6886 24.72L28.6826 24.7186C28.6826 24.7186 28.6846 24.7179 28.6851 24.7178Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.5971 22.9501C28.5971 22.9501 28.7925 23.4619 28.4894 23.7583C28.4894 23.7583 28.0942 23.6416 27.8989 23.2308L28.0651 23.1993L28.1505 22.9434L28.4334 23.0691L28.5971 22.9501Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.0472 22.1274C28.0472 22.1274 28.3533 22.5817 28.1253 22.9391C28.1253 22.9391 27.714 22.9148 27.4307 22.5589L27.5854 22.4907L27.6105 22.2221L27.9145 22.2805L28.0472 22.1274Z",
					fill: "#50AF69"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0007 26.4009L24.6675 26.9007C24.6106 26.986 24.6218 27.0997 24.6945 27.1723L25.0007 27.4785L25.307 27.1723C25.3795 27.0997 25.3908 26.986 25.3339 26.9007L25.0007 26.4009Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.1429 26.9007L25.0006 26.4009L24.8582 26.9007C24.8339 26.986 24.8387 27.0997 24.8697 27.1723L25.0006 27.4785L25.1314 27.1723C25.1624 27.0996 25.1673 26.986 25.1429 26.9007Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0007 21.929V20.582C25.0007 20.582 24.4889 21.3184 24.5697 22.3959",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.7051 21.9336C21.9647 23.5406 22.7241 24.8629 22.8835 25.1118C22.8877 25.1184 23.9408 23.4149 23.9408 23.4149L22.7051 21.9336Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.4843 24.1519C23.3675 23.7881 23.3506 23.3633 23.4908 22.8759L23.0326 22.3267C22.6561 23.3411 22.8119 24.0901 23.1888 24.6276C23.2812 24.4789 23.384 24.3135 23.4843 24.1519Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.9226 23.5047C23.8904 23.5047 23.8587 23.4903 23.8374 23.463L22.4861 21.7256C22.4495 21.6786 22.458 21.6109 22.505 21.5745C22.5522 21.5379 22.6196 21.5465 22.6562 21.5934L24.0074 23.3308C24.044 23.3778 24.0355 23.4455 23.9886 23.4819C23.9689 23.4973 23.9456 23.5047 23.9226 23.5047Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.7677 23.6035C21.3367 27.9139 24.785 26.8362 25.0004 26.4053L22.8453 25.3277L23.2763 24.4656L21.7677 23.6035Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.8097 24.0996L22.209 23.7393C22.0738 26.3006 23.4416 26.7271 24.4505 26.6C23.6326 26.4902 22.8154 25.8863 22.8097 24.0996Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.276 24.5732C23.2564 24.5732 23.2367 24.5679 23.2189 24.5568L21.4949 23.4794C21.4445 23.4479 21.4292 23.3814 21.4607 23.3311C21.4922 23.2803 21.5586 23.2651 21.6093 23.2968L23.3333 24.3742C23.3837 24.4057 23.399 24.4722 23.3675 24.5225C23.347 24.5553 23.3118 24.5732 23.276 24.5732Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.2958 21.9292C28.0362 23.5362 27.2768 24.8585 27.1174 25.1074C27.1132 25.1141 26.0601 23.4105 26.0601 23.4105L27.2958 21.9292Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.5163 24.1475C26.6331 23.7837 26.65 23.3589 26.5098 22.8715L26.968 22.3223C27.3444 23.3367 27.1887 24.0857 26.8118 24.6232C26.7193 24.4746 26.6166 24.3091 26.5163 24.1475Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.0778 23.5007C26.0548 23.5007 26.0314 23.4933 26.0118 23.4779C25.9648 23.4415 25.9564 23.3737 25.993 23.3268L27.3442 21.5894C27.3809 21.5425 27.4484 21.5341 27.4954 21.5705C27.5424 21.6069 27.5509 21.6747 27.5143 21.7216L26.163 23.459C26.1418 23.4864 26.11 23.5007 26.0778 23.5007Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.2332 23.5991C28.6642 27.9095 25.2159 26.8318 25.0005 26.4009L27.1557 25.3233L26.7246 24.4612L28.2332 23.5991Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.1911 24.0952L27.7918 23.7349C27.9269 26.2962 26.5592 26.7227 25.5503 26.5956C26.3682 26.4858 27.1853 25.882 27.1911 24.0952Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.7246 24.5689C26.6887 24.5689 26.6536 24.551 26.6331 24.5181C26.6015 24.4678 26.617 24.4013 26.6673 24.3698L28.3913 23.2925C28.442 23.2606 28.5083 23.276 28.5398 23.3267C28.5714 23.377 28.556 23.4435 28.5056 23.4751L26.7816 24.5524C26.7638 24.5636 26.7441 24.5689 26.7246 24.5689Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0003 24.6769C25.4764 24.6769 25.8624 24.2909 25.8624 23.8147C25.8624 23.3386 25.4764 22.9526 25.0003 22.9526C24.5242 22.9526 24.1382 23.3386 24.1382 23.8147C24.1382 24.2909 24.5242 24.6769 25.0003 24.6769Z",
					fill: "#FFE6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0004 24.2454C25.2385 24.2454 25.4314 24.0524 25.4314 23.8144C25.4314 23.5763 25.2385 23.3833 25.0004 23.3833C24.7623 23.3833 24.5693 23.5763 24.5693 23.8144C24.5693 24.0524 24.7623 24.2454 25.0004 24.2454Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0006 25.2155C24.9408 25.2155 24.8926 25.1674 24.8926 25.1078V23.8147C24.8926 23.7552 24.9408 23.707 25.0006 23.707C25.0603 23.707 25.1086 23.7552 25.1086 23.8147V25.1078C25.1086 25.1674 25.0603 25.2155 25.0006 25.2155Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.9455 26.3832H22.1714L22.8449 25.1016H27.1732L27.9455 26.3832Z",
					fill: "#5AA0E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.1758 25.3416H26.6774L26.2104 24.8745C26.1884 24.8525 26.1615 24.8359 26.1321 24.8262L25.9695 24.772C25.9109 24.7524 25.8466 24.7611 25.7952 24.7953L25.2761 25.1414L25.1758 25.3416Z",
					fill: "#FFB750"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.665 25.4221H26.4573L25.8998 24.8646C25.8736 24.8384 25.8416 24.8186 25.8063 24.8069L25.6123 24.7422C25.5424 24.719 25.4655 24.7291 25.4042 24.7702L24.7846 25.1833L24.665 25.4221Z",
					fill: "#FFC455"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.0415 25.5122H26.2059L25.5326 24.8389C25.501 24.8073 25.4624 24.7834 25.4198 24.7692L25.1854 24.6911C25.101 24.6629 25.0082 24.6753 24.9342 24.7247L24.1859 25.2235L24.0415 25.5122Z",
					fill: "#FFCD55"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.4243 25.5929H25.9024L25.1315 24.822C25.0952 24.7857 25.0511 24.7584 25.0023 24.7421L24.734 24.6527C24.6372 24.6205 24.5311 24.6347 24.4462 24.6913L23.5894 25.2624L23.4243 25.5929Z",
					fill: "#FFD25A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.4141 25.7543H25.6468L24.6412 24.7488C24.5939 24.7015 24.5362 24.6657 24.4727 24.6447L24.1227 24.528C23.9965 24.486 23.8579 24.5044 23.7473 24.5782L22.6296 25.3233L22.4141 25.7543Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.234 24.008H24.7681L24.8754 23.5581H25.0373C25.0897 23.5581 25.1354 23.5941 25.1476 23.6452L25.234 24.008Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.2068 24.0801H24.7885C24.7542 24.0801 24.7266 24.0523 24.7266 24.0182V23.9975C24.7266 23.9632 24.7544 23.9355 24.7885 23.9355H25.2068C25.2411 23.9355 25.2688 23.9634 25.2688 23.9975V24.0182C25.2688 24.0522 25.2409 24.0801 25.2068 24.0801Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9309 23.7629L24.8261 23.7364C24.7944 23.7284 24.7807 23.6913 24.7996 23.6647L24.8755 23.5581L24.9309 23.7629Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.4626 22.7075C24.4575 22.7471 24.4523 22.7867 24.4473 22.8263C24.6147 22.7246 24.7995 22.6637 25.0002 22.6637C25.2007 22.6639 25.3855 22.7244 25.5531 22.8263C25.548 22.7866 25.5429 22.7471 25.5378 22.7075C25.3712 22.6206 25.1919 22.5706 25.0002 22.5708C24.8086 22.5706 24.6293 22.6205 24.4626 22.7075Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.4694 22.6563C24.4644 22.6959 24.4592 22.7355 24.4541 22.7751C24.6197 22.6732 24.8022 22.6122 25.0003 22.6119C25.1983 22.6121 25.3809 22.6731 25.5465 22.7751C25.5414 22.7354 25.5362 22.6959 25.5312 22.6563C25.3664 22.5687 25.1895 22.5191 25.0002 22.519C24.8111 22.519 24.6342 22.5689 24.4694 22.6563Z",
					fill: "#5AA0E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.4753 22.6085C24.4702 22.648 24.465 22.6877 24.46 22.7272C24.6239 22.6251 24.8044 22.5636 25 22.5637C25.1957 22.5637 25.3761 22.6251 25.54 22.7272C25.535 22.6877 25.5298 22.648 25.5247 22.6085C25.3618 22.521 25.1869 22.4708 24.9999 22.4707C24.8133 22.4706 24.6384 22.5209 24.4753 22.6085Z",
					fill: "#9BC800"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.4826 22.5539C24.4775 22.5936 24.4724 22.6331 24.4673 22.6727C24.6294 22.5702 24.8073 22.5085 25.0004 22.5085C25.1934 22.5087 25.3714 22.57 25.5335 22.6727C25.5284 22.6331 25.5232 22.5935 25.5182 22.5539C25.3571 22.466 25.1848 22.4156 25.0005 22.4155C24.816 22.4157 24.6437 22.466 24.4826 22.5539Z",
					fill: "#FFE14E"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.4895 22.5002C24.4844 22.5397 24.4792 22.5794 24.4741 22.6189C24.6344 22.5161 24.8098 22.4544 25.0002 22.4543C25.1906 22.4545 25.3661 22.516 25.5263 22.6189C25.5212 22.5794 25.516 22.5397 25.5109 22.5002C25.3519 22.412 25.1818 22.3614 25.0002 22.3613C24.8186 22.3615 24.6484 22.4119 24.4895 22.5002Z",
					fill: "#FFB14E"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.4926 22.4775C24.4891 22.5053 24.4854 22.533 24.4819 22.5607C24.64 22.4578 24.8131 22.3954 25.0006 22.3954C25.1881 22.3953 25.361 22.4576 25.5192 22.5607C25.5157 22.533 25.5121 22.5053 25.5086 22.4775C25.3504 22.3893 25.1813 22.3386 25.0007 22.3384C24.8199 22.3382 24.6508 22.3892 24.4926 22.4775Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.0177 26.5087H21.9832C21.9435 26.5087 21.907 26.4868 21.8882 26.4518C21.8695 26.4167 21.8716 26.3741 21.8936 26.3412L24.9109 21.8153C24.9508 21.7556 25.0502 21.7556 25.0902 21.8153L28.1074 26.3412C28.1294 26.3743 28.1315 26.4168 28.1128 26.4518C28.094 26.4868 28.0574 26.5087 28.0177 26.5087ZM22.1845 26.2932H27.8164L25.0004 22.0694L22.1845 26.2932Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0006 20.9053C24.9408 20.9053 24.8926 20.8571 24.8926 20.7976V20.3665C24.8926 20.3069 24.9408 20.2588 25.0006 20.2588C25.0603 20.2588 25.1086 20.3069 25.1086 20.3665V20.7976C25.1086 20.8571 25.0603 20.9053 25.0006 20.9053Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.216 20.9054H24.785C24.7254 20.9054 24.6772 20.8572 24.6772 20.7977C24.6772 20.7381 24.7254 20.6899 24.785 20.6899H25.216C25.2756 20.6899 25.3237 20.7381 25.3237 20.7977C25.3237 20.8572 25.2756 20.9054 25.216 20.9054Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0003 28.6641C24.9926 28.6641 24.9846 28.6632 24.977 28.6616C24.8715 28.638 24.5196 28.5536 24.4158 28.4508C24.2839 28.3198 24.2833 28.1062 24.4139 27.9743C24.4774 27.9105 24.5618 27.8752 24.6517 27.875H24.6529C24.7424 27.875 24.8266 27.9097 24.8902 27.9729C24.994 28.076 25.081 28.4271 25.1052 28.5322C25.1135 28.5683 25.1028 28.6062 25.0767 28.6324C25.0564 28.6528 25.0288 28.6641 25.0003 28.6641ZM24.6529 28.0903C24.6242 28.0998 24.5897 28.1031 24.5667 28.1261C24.5197 28.1733 24.52 28.2504 24.5675 28.2977C24.5936 28.323 24.7101 28.3672 24.8498 28.4069C24.8089 28.2678 24.7641 28.1517 24.7383 28.1256L24.8142 28.0492L24.7382 28.1256C24.7154 28.1027 24.6851 28.0903 24.6529 28.0903Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0013 28.6638C24.9729 28.6638 24.9452 28.6525 24.9248 28.6319C24.8988 28.6057 24.888 28.5677 24.8963 28.5317C24.9205 28.4265 25.0076 28.0755 25.1113 27.9724C25.1752 27.909 25.2513 27.8803 25.3498 27.8745C25.4398 27.8747 25.5241 27.9101 25.5875 27.9738C25.7185 28.1059 25.7176 28.3194 25.5858 28.4501C25.4819 28.5532 25.13 28.6376 25.0245 28.6612C25.017 28.6629 25.009 28.6638 25.0013 28.6638ZM25.1874 28.0488L25.2633 28.1252C25.2375 28.1513 25.1927 28.2675 25.1519 28.4065C25.2915 28.3668 25.408 28.3229 25.4342 28.2971C25.4815 28.2501 25.4818 28.1731 25.4348 28.1258C25.412 28.1028 25.3816 28.09 25.3492 28.09H25.3488C25.3166 28.09 25.2863 28.1024 25.2635 28.1252L25.1874 28.0488ZM25.1874 28.0488H25.1896H25.1874Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.5706 29.3104C24.511 29.3104 24.4629 29.2622 24.4629 29.2026C24.4629 28.7107 24.9335 28.4697 24.9535 28.4597C25.007 28.4329 25.0712 28.4548 25.0978 28.5076C25.1246 28.5607 25.1032 28.6253 25.0503 28.6523C25.0465 28.6542 24.6785 28.8452 24.6785 29.2026C24.6784 29.2622 24.6302 29.3104 24.5706 29.3104Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.4321 29.3103C25.3725 29.3103 25.3244 29.2621 25.3244 29.2026C25.3244 28.8452 24.9564 28.654 24.9526 28.6523C24.8997 28.6253 24.8784 28.5607 24.9051 28.5076C24.9319 28.4548 24.996 28.4329 25.0494 28.4597C25.0694 28.4698 25.54 28.7106 25.54 29.2026C25.5398 29.2621 25.4917 29.3103 25.4321 29.3103Z",
					fill: "#41479B"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53292",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSvFlag);
export { ForwardRef as ReactComponent };
